import { memo } from 'react'
import * as Styled from './styled'
import { useTimelineContext } from 'context/TimelineContext'

const MagnetizingLine: React.FC = () => {
  const { magnetizingLineRef } = useTimelineContext()

  return <Styled.MagnetizingLine ref={magnetizingLineRef} />
}

export default memo(MagnetizingLine)
